import React from "react";
import { ListItem as MuiListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

type SidebarListItemProps = {
  icon?: React.ReactNode;
  text: React.ReactNode;
  selected?: boolean;
  href: string;
}

const SidebarListItem: React.FC<SidebarListItemProps> = ({
  icon,
  text,
  selected,
  href,
}) => (
  <MuiListItem disablePadding>
    <ListItemButton selected={!!selected} href={href}>
      {icon && (
        <ListItemIcon style={{ minWidth: "36px" }}>
          {icon}
        </ListItemIcon>
      )}
      <ListItemText primary={text} slotProps={{ primary: { component: "span", variant: "body1" } }} />
    </ListItemButton>
  </MuiListItem>
);

export default SidebarListItem;


